import type { OrgMemberView, OrgMemberWorkspaceRef, RegistryGroupRef } from "@/api";
import type { UserRole } from "@/app/userRole";
import { TableRow } from "@carbon6/c6-frontend-design";

// 합쳐진 멤버 관리 테이블의 한 행. org 디렉터리 멤버(가입+미가입)를 평탄화한다. 안정 키는
// github_user_id 다(login 이 바뀌어도 불변). 미가입이면 memberUuid·tier 가 null 이다.
export class OrgMemberTableRow extends TableRow {
  readonly githubUserId: number;
  readonly githubLogin: string;
  readonly githubTeams: readonly string[];
  readonly registered: boolean;
  readonly memberUuid: string | null;
  readonly tier: UserRole | null;
  readonly lastLoginAt: string | null;
  readonly registryGroups: readonly RegistryGroupRef[];
  // 매핑된 workspace 스냅샷. 가입자만 값이 있고 미가입은 빈 배열이다.
  readonly workspaces: readonly OrgMemberWorkspaceRef[];

  constructor(member: OrgMemberView) {
    super(null);
    this.githubUserId = member.github_user_id;
    this.githubLogin = member.github_login;
    this.githubTeams = member.github_teams;
    this.registered = member.registered;
    this.memberUuid = member.member_uuid;
    this.tier = member.tier;
    this.lastLoginAt = member.last_login_at;
    this.registryGroups = member.registry_groups;
    this.workspaces = member.training_workspaces;
  }

  getRowId(): string {
    return String(this.githubUserId);
  }

  // 모든 행을 표시한다. 가시성은 서버 조회가 정한다.
  canShow(): boolean {
    return true;
  }

  // 선택 UI 가 없는 목록이다. 그래서 선택 대상이 아니다.
  canSelect(): boolean {
    return false;
  }
}
